import React, { useEffect, useState } from 'react';
import DataGridList from "../../components/CommonList/DataGridList.js";
import api from '../../services/api';

const Index = () => {
    const [Tokens, setTokens] = useState([]);
    const [Servers, setServers] = useState([]);

    const columns = [
        { name: 'Token', index: 'token_name', type: 'text' },
        { name: 'Broadcast ID', index: 'broadcast_id', type: 'number' },
        { name: 'Type', index: 'stream_type', type: 'text' },
        { name: 'Stream URL', index: 'url', type: 'text' },
        { name: 'AM Server', index: 'server_name', type: 'text' },
        { name: 'PDT', index: 'pdt_status', type: 'text' },
        { name: 'VOD', index: 'retain', type: 'bool' },
        { name: 'Enabled', index: 'is_active', type: 'input-switch' },
        { name: 'Last Registered', index: 'last_registered', type: 'datetime' },
        { name: 'Error', index: 'last_register_error', type: 'text' }
    ];

    const options = {
        crud: true,
        add: {
            route: "/manage/amstream/form"
        },
        edit: {
            route: "/manage/amstream/form"
        },
        details: {
            route: ""
        },
        delete: {
            route: "amstream/"
        },
        enabledOpt: {
            url_edit: 'amstream/',
            field: null
        },
        export: {
            route: ""
        },
    }

    const url = "amstreams"

    const filters = [
        { name: "Token", index: 'token', type: 'dropdown', list: Tokens, placeholder: 'Token' },
        { name: "AM Server", index: 'server', type: 'dropdown', list: Servers, placeholder: 'AM Server' },
        { name: "Search", index: 'search', type: 'text'},
    ];

    const getTokens = async () => {
        try {
            api.get('tokens?limit=1000')
                .then(function (response) {
                    if (response.status == 200) {
                        setTokens(response.data.results);
                    }
                })
                .catch(function (error) {
                });
        } catch (err) {
        }
    }

    const getServers = async () => {
        try {
            api.get('amservers?limit=1000')
                .then(function (response) {
                    if (response.status == 200) {
                        setServers(response.data.results);
                    }
                })
                .catch(function (error) {
                });
        } catch (err) {
        }
    }

    useEffect(() => {
        getTokens();
        getServers();
    }, []);

    return (
        <DataGridList url={url} columns={columns} options={options} filters={filters}/>
    );
};

export default Index;
